import LabelPurchasingTypeEnum from '@enums/modules/creatingWarehouseReceivingOrder/labelPurchasing'

export default {
  Parcel: 'packagingType.Parcel',
  PalletizedContainerOrLTL: 'packagingType.PalletizedContainerOrLTL',
  FloorLoadedContainer: 'packagingType.FloorLoadedContainer',
  labelPurchaseTypes: [
    { id: 1, name: LabelPurchasingTypeEnum.PurchaseLabels },
    { id: 2, name: LabelPurchasingTypeEnum.UseOwnLabels }
  ]
}
